import { ComponentView, ViewGenerator, ObservableArray, ViewModel } from "binder";
import { TableViewModel } from "./table-viewModel"

export class TableView extends ComponentView<TableViewModel>{
    GetViewUniqueId(): string {
        return "V-48358515-0456-4D23-A3FA-8B0925CE1AB1"
    }
    loadHtml(): string {
        let element = require('./table.html').default;
        let style = require('./table.less');
        return element;
    }
    constructor() {
       super();
       this.displayContentForTBody = false;
    }

    private itemTemplate : Node;
    templateSelector(vm){
        return ViewGenerator.GetNodeByTemplate(vm,this.itemTemplate);
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLTableSectionElement || node instanceof HTMLTableColElement){
                if(node.nodeName.toUpperCase()=='THEAD' || node.nodeName.toUpperCase()=="COLGROUP"){
                    this.firstlevelElement.prepend(node);
                    // let headerCells = node.rows[0].cells;
                    // for(let i=0;i<headerCells.length;i++){
                    //     let cell = headerCells.item(i);
                    //     this.makeCellSortable(cell);
                    // }
                }else if(node.nodeName.toUpperCase()=='TBODY' && node.classList.contains('notemplate')==false){
                    if(node.classList.contains("template")){
                        let template = <HTMLElement>node;
                        this.itemTemplate = this.removeAsTemplate(template);
                        this.displayContentForTBody = true;
                    }else if(node.childElementCount>0 && node.children[0].classList.contains("template")){
                        let template = <HTMLElement>node.children[0];
                        this.itemTemplate = this.removeAsTemplate(template);
                    }
                }else{
                    this.firstlevelElement.append(node);
                }
            }
        });
    }

    // makeCellSortable(cell:HTMLTableDataCellElement){
    //     (<any>cell).sortingInfo={
    //         fieldName:cell.attributes['data-b-sort-column'],
    //         direction:0,
    //         itemsList : this.items
    //     }
    //     cell.addEventListener('click',function(e){
    //         let sortInfo = (<any>this).sortingInfo;
    //         sortInfo.itemsList.sort((x,y)=>{

    //         })
    //     });
    // }

    public set items(v: ObservableArray<ViewModel>) { this._items = v; } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set displayContentForTBody(v: boolean) { this._displayContentForTBody = v; } public get displayContentForTBody(): boolean { return this._displayContentForTBody;} private _displayContentForTBody: boolean;

}
